import { Children, cloneElement, isValidElement } from "react";
import Box from "@mui/material/Box";

const WIDE_BENTO_QUERY = "@container (min-width: 980px)";

export const PerformingAssetsBentoItem = ({
  span = 6,
  columnStart,
  children,
}) => (
  <Box
    sx={{
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      "& > *": { flex: 1 },
      gridColumn: "1 / -1",
      [WIDE_BENTO_QUERY]: {
        gridColumn: columnStart
          ? `${columnStart} / span ${span}`
          : `span ${span}`,
      },
    }}
  >
    {children}
  </Box>
);

const GRID_COLUMNS = 12;

// Expands an item to full width when it ends up alone in its grid row
const expandLonelyItems = (children) => {
  const items = Children.toArray(children).filter(isValidElement);
  const result = [];
  let row = [];
  let rowSpan = 0;

  const flushRow = () => {
    if (row.length === 1 && rowSpan < GRID_COLUMNS) {
      result.push(cloneElement(row[0], { span: GRID_COLUMNS }));
    } else {
      result.push(...row);
    }
    row = [];
    rowSpan = 0;
  };

  items.forEach((item) => {
    const span = item.props.span ?? 6;
    if (rowSpan + span > GRID_COLUMNS) flushRow();
    row.push(item);
    rowSpan += span;
    if (rowSpan >= GRID_COLUMNS) flushRow();
  });
  flushRow();

  return result;
};

const PerformingAssetsBento = ({ children }) => (
  <Box sx={{ width: "100%", containerType: "inline-size" }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr)",
        gap: 2,
        alignItems: "stretch",
        [WIDE_BENTO_QUERY]: {
          gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
        },
      }}
    >
      {expandLonelyItems(children)}
    </Box>
  </Box>
);

export default PerformingAssetsBento;
